import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "editor-view" }
const _hoisted_2 = { class: "editor" }
const _hoisted_3 = { class: "result" }
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.eval()))
    }, "RUN"),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue) = $event))
      }, null, 512), [
        [_vModelText, _ctx.inputValue]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("textarea", {
        disabled: "",
        value: _ctx.evalValue
      }, null, 8, _hoisted_4)
    ])
  ]))
}